import { Column } from '@shared/models/common/csv/column';

export const columns: Column[] = [
  { id: 'LEAD_NAME', name: 'LEAD NAME', mapper: 'col1' },
  { id: 'TICKET_NUMBER', name: 'TICKET NUMBER', mapper: 'col2' },
  { id: 'TICKET_PROVIDER', name: 'TICKET PROVIDER', mapper: 'col3' },
  { id: 'EVENT', name: 'EVENT', mapper: 'col4' },
  { id: 'NUMBER_IN_PARTY', name: 'NUMBER IN PARTY', mapper: 'col5' },
  { id: 'PRICE_PER_TICKET', name: 'PRICE PER TICKET', mapper: 'col6' },
  { id: 'PRICE_PAID', name: 'PRICE PAID', mapper: 'col7' },
  { id: 'FOOD_REQUEST', name: 'FOOD REQUEST / ALLERGEN', mapper: 'col8' },
  { id: 'FOOD_ORDER', name: 'FOOD ORDER', mapper: 'col9' },
  { id: 'TICKET TYPE', name: 'TICKET TYPE', mapper: 'col10' },
];